import { Link } from '../../atoms/link/Link';
import { Select } from '../../atoms/select/Select';
import { CarretArrowDownJAG } from '../../atoms/icons';
import styles from './CmsNavigation.module.scss';
import { theme } from './_vars';
import app from '@frontastic/catwalk/src/js/app/app';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';
import { useMedia } from 'react-use';

const CmsNavigation = ({ activeMenu = '', activePage, navigationLinks }) => {
  const isMobile = useMedia('(max-width: 767px)', false);

  const onSelect = (value) => app.getRouter().history.push(value);

  return (
    <>
      {!isMobile && (
        <div className={styles.container}>
          <div className={styles.navBlock}>
            {navigationLinks &&
              navigationLinks.map((link, index) => {
                return (
                  <Link
                    key={`link_${index}`}
                    className={clsx(
                      styles.navItem,
                      link.tree?.configuration?.path === activeMenu && styles.navItemActive,
                    )}
                    link={{ reference: link?.reference }}
                  >
                    <span className={styles.navName}>{link.name}</span>
                  </Link>
                );
              })}
          </div>
        </div>
      )}
      {isMobile && (
        <div className={styles.mobileNavigation}>
          <Select
            onSelect={onSelect}
            id="77"
            name="linksTo"
            variant="normal"
            customIcon={theme === 'jag' && CarretArrowDownJAG}
          >
            {navigationLinks &&
              navigationLinks.map((link, index) => (
                <Select.Option
                  key={`sublink_${index}`}
                  index={link.reference}
                  label={'Help: ' + activePage}
                  value={link?.tree?.configuration?.path}
                  htmlContent={<span>{link.name}</span>}
                />
              ))}
          </Select>
        </div>
      )}
    </>
  );
};

CmsNavigation.propTypes = {
  activeMenu: PropTypes.string,
};

export default CmsNavigation;
